// src/redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import accountsReducer from "./slices/AccountsSlice";
import authReducer from "./slices/authSlice";
import defaultReducer from "./slices/DefaultSlice";
import disputesReducer from "./slices/DisputesSlice";
import faqsReducer from "./slices/FaqsSlice";
import featuredvendorsReducer from "./slices/FeaturedvendorsSlice";
import membersReducer from "./slices/MembersSlice";
import referralHistoryReducer from "./slices/referralHistorySlice";
import referralpaymentsReducer from "./slices/ReferralpaymentsSlice";
import referralsReducer from "./slices/ReferralsSlice";
import rewardsReducer from "./slices/RewardsSlice";
import vendor_profile_update_requestsReducer from "./slices/Vendor_profile_update_requestsSlice";
import vendorrecommendationsReducer from "./slices/VendorrecommendationsSlice";
import vendorReducer from "./slices/VendorSlice";
import vendorsonhomeReducer from "./slices/VendorsonhomeSlice";
import waitlistReducer from "./slices/WaitlistSlice";
import industryChildReducer from "./slices/IndustrysectorchildSlice";
import industrysectorcategoriesReducer from "./slices/IndustrysectorcategoriesSlice";
import favouriteVendorsReducer from "./slices/FavouriteVendorsSlice";
import payoutRequestsReducer from "./slices/PayoutRequestsSlice";
import charitiesReducer from "./slices/charitiesSlice";
import referralRewardsReducer from "./slices/referralRewardsSlice";
import onboardingReferralsReducer from "./slices/onboardingReferralsSlice";
import walletReducer from "./slices/WalletSlice";
import celebrationReducer from "./slices/CelebrationSlice";

export const store = configureStore({
  reducer: {
    default: defaultReducer,
    referrals: referralsReducer,
    vendor: vendorReducer,
    referralpayments: referralpaymentsReducer,
    disputes: disputesReducer,
    waitlist: waitlistReducer,
    faqs: faqsReducer,
    featuredvendors: featuredvendorsReducer,
    vendorrecommendations: vendorrecommendationsReducer,
    accounts: accountsReducer,
    members: membersReducer,
    vendorsonhome: vendorsonhomeReducer,
    rewards: rewardsReducer,
    industryChild: industryChildReducer,
    industrysectorparent: industrysectorcategoriesReducer,
    vendor_profile_update_requests: vendor_profile_update_requestsReducer,
    auth: authReducer,
    referralHistory: referralHistoryReducer,
    favouriteVendors: favouriteVendorsReducer,
    payoutRequests: payoutRequestsReducer,
    charities: charitiesReducer,
    referralRewards: referralRewardsReducer,
    onboardingReferrals: onboardingReferralsReducer,
    wallet: walletReducer, 
    celebration: celebrationReducer,
  },
  middleware: (getDefault) => getDefault({ serializableCheck: false }),
});

export default store;
